(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marqueewithimage"] && !Shopify.designMode) return;
  try {
    
  if(typeof LunaMarqueeSwiper !== 'function') {
    class LunaMarqueeSwiper extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.swiper');
        this.settings = {
          speed: parseInt(this.dataset.speed),
          autoplay: {
            disableOnInteraction: false,
  pauseOnMouseEnter: false,
  delay: 100
          },
          on: {
            init: () => {
              this.querySelector('.swiper-wrapper').style.opacity = 1;
            },
          },
          centeredSlides: true,
          freeMode: true,
          loop: true,
          simulateTouch: false,
grabCursor: false,
          loopedSlides: Math.max(parseInt(this.dataset.mobile), parseInt(this.dataset.size)),
          slidesPerView: parseInt(this.dataset.mobile),
          spaceBetween: parseInt(this.dataset.spaceBetween),
          breakpoints: {
            750: {
              loopedSlides: Math.max(parseInt(this.dataset.tablet), parseInt(this.dataset.size)),
              slidesPerView: parseInt(this.dataset.tablet)
            },
            1250: {
              loopedSlides: Math.max(parseInt(this.dataset.desc), parseInt(this.dataset.size)),
              slidesPerView: parseInt(this.dataset.desc)
            },
            1800: {
              loopedSlides: Math.max(parseInt(this.dataset.desc) + 2, parseInt(this.dataset.size)),
              slidesPerView: parseInt(this.dataset.desc) + 2
            }
          }
        };
        this.swipper;

        this.init();
        document.addEventListener("shopify:section:load", (event) => {
          this.appendAssets();
          this.init();
        });

        window.addEventListener('resize', () => {
          setTimeout(() => {
            this.swipper.update();
            this.swipper.slideToLoop(this.swipper.realIndex, 0);
          }, 300);
        })
      }
      appendAssets() {
        const link = document.createElement('link');
        const script = document.createElement('script');

        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';

        document.head.appendChild(link);
        document.body.appendChild(script);
      }
      init() {
        if (typeof Swiper !== 'function') {
          this.appendAssets();
          this.swiperChecker();
        } else {
          this.initSlider();
        }
      }
      initSlider() {
        if (this.swipper && this.swipper.destroy) {
          this.swipper.destroy();
          this.swipper = null;

          this.swipper = new Swiper(this.slider, this.settings);
        } else {
          this.swipper = new Swiper(this.slider, this.settings);
        }
      }
      swiperChecker() {
        const interval = setInterval(() => {
          if (typeof Swiper !== 'function') {
            this.swiperChecker();
          } else {
            clearInterval(interval);
            this.initSlider();
          }
        }, 100);
      }
    }
    customElements.define('luna-marquee-swiper', LunaMarqueeSwiper);
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticker-animated')) {
    class StickerAnimated extends HTMLElement {
      constructor() {
        super()
        this.animationSpeed = parseFloat(this.dataset.animationSpeed)

        this.init()

        document.addEventListener('readystatechange', function() {
          if(document.readyState == 'interactive') {
          }
        })
        document.addEventListener("shopify:section:load", (event) => {
          this.init()
        });
      }
      init() {
        this.selecter = ".stckrimg"
        this.stckrimgs = this.querySelectorAll(this.selecter);
        this.scroll();
      }
      scroll() {
        Array.from(this.stckrimgs).forEach(stckrimg => {
          window.addEventListener("scroll", () => {
            const section = stckrimg.closest(`.shopify-section`)
            const LT__section = stckrimg.closest(`.luna-templates__animated-sticker`)
            const sticker = this.querySelector('.luna-templates-animated-sticker');
            const {bottom, top} = sticker.getBoundingClientRect();

            if (top > 0 && (bottom - window.innerHeight) < 0) {
              if (LT__section.dataset.animation == "spin-scroll") {
                stckrimg.style.rotate = (bottom * this.animationSpeed) + "deg";
                stckrimg.style.top = 0 + "px";
              }

              if (LT__section.dataset.animation == "float-scroll") {
                stckrimg.style.rotate = 0 + "deg";
                // stckrimg.style.top = ((bottom + (window.innerHeight / 2)) * this.animationSpeed) + "px";
                stckrimg.style.top = (((sticker.offsetTop + this.offsetTop) - (window.scrollY + (window.innerHeight / 2))) * this.animationSpeed) + "px";
              }
            }
          }, {
            passive: true,
            capture: false,
          })
        })
      }
    }
    customElements.define('sticker-animated', StickerAnimated)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["typographywithimage"] && !Shopify.designMode) return;
  try {
    
  if(typeof LunaWords !== 'function') {
    class LunaWords extends HTMLElement {
      constructor() {
        super()

        this.init()
        document.addEventListener("shopify:section:load", (event) => {
          this.init();
        });
      }
      init() {
        this.idx = 0
        this.template = this.querySelector('template').content.cloneNode(true)
        const div = document.createElement('div')
        div.className = 'lt-creative_typography-title'
        div.innerHTML = this.processContent(this.template.querySelector('.luna-templates_html').innerHTML);
        div.append(...this.template.querySelector('.luna-templates_blocks').childNodes);

        this.querySelector('.lt-creative_typography-title')?.remove()
        this.append(div)
      }
      processContent(html) {
        return html.replace(/(<[^>]+>.*?<\/[^>]+>)|(\S+)/g, (match, tag) => {
          this.idx += 1
          if(tag) {
            const newtag = tag.replace(/<([a-zA-Z0-9]+)([^>]*?)>(.*?)<\/\1>/g, (_, inner_tag, attrs, content) => content.split(' ').map((word, i) => {
              if(i != 0) this.idx += 1
              const c = `<span class="lt-creative_typography-word" style="order: ${ this.idx }"><${inner_tag}${attrs}>${word}</${inner_tag}></span>`

              return c
            }).join(' '));
            return newtag
          } else {
            return `<span class="lt-creative_typography-word" style="order: ${ this.idx }">${ match }</span>`
          }
        });
      }
    }

    customElements.define('luna-words', LunaWords)
  }

  } catch(e) { console.error(e); }
})();
})();
